export enum Locale {
  zhHantHK = "zh-Hant-HK",
  en = "en",
}
